import React, { FC } from 'react';
import { Field, change } from 'redux-form';
import { connect } from 'react-redux';
import QuantityPicker from '@common/components/QuantityPicker';
import { ButtonWrapper, PerStayWrapper } from './PerStay.styles';
import { JourneyParams } from 'shared-types';
import { useTranslations } from '@lang';

interface PerStayProps {
  id: number;
  maxQuantity: number | null;
  journeyParams: JourneyParams;
  formName: string;
  extrasByRoom: Record<string, { isSelected?: boolean; quantity: number }[]>;
  dispatch: any;
  guests: { room: number; title: string; gender: string; firstName: string; lastName: string }[];
  pricingType: string;
}

const MultiRoomPerStayComponent: FC<PerStayProps> = ({
  id,
  maxQuantity,
  journeyParams,
  formName,
  extrasByRoom,
  dispatch,
  guests,
  pricingType,
}) => {
  const { rooms } = journeyParams;
  const { t } = useTranslations();
  return (
    <PerStayWrapper>
      {(rooms || []).map((_, i) => {
        return (
          <ButtonWrapper key={i}>
            <div>{`${t('common.room')} ${i + 1}`}</div>
            <Field
              component={QuantityPicker}
              name={`extras.room-${i}.${id}.quantity`}
              maxValue={
                pricingType === 'per_stay'
                  ? 1
                  : (guests || []).filter((guest) => guest.room === i + 1)?.length || maxQuantity
              }
              minValue={0}
              showZeroCounter
              input={{
                value: extrasByRoom?.[`room-${i}`]?.[id]?.quantity || 0,
                onChange: (e) => {
                  dispatch(change(formName, `extras.room-${i}.${id}.isSelected`, e > 0));
                  dispatch(change(formName, `extras.room-${i}.${id}.quantity`, e));
                },
              }}
            />
          </ButtonWrapper>
        );
      })}
    </PerStayWrapper>
  );
};

const mapStateToProps = (state: any, ownProps: PerStayProps) => {
  const { formName } = ownProps;
  const extrasByRoom = state.form[formName]?.values?.extras;
  const guests = state.form[formName]?.values?.guests || [];

  return {
    extrasByRoom,
    guests,
    formName,
  };
};

export const MultiRoomPerStay: any = connect(mapStateToProps)(MultiRoomPerStayComponent);
